export class ChangeAssignmentDate {
    assignmentNr: string;
    date: Date;

    constructor(assNr: string, endDate: Date) 
    {
        this.assignmentNr = assNr;
        this.date = endDate;
    }
}
